import React from 'react'
import { buildCanonicalURL } from 'lib/utils'
import Head from 'next/head'
import { useIntl } from 'react-intl'
import { useMarket } from 'src/hooks/useMarket'
import { getJsonLd } from 'client/components/JsonLd/utils'

export function ReviewsHead() {
  const intl = useIntl()
  const { language, market, subdomain, topdomain } = useMarket()

  const title = `${intl.formatMessage({ id: 'global.reviews-metatitle' })}`
  const description = `${intl.formatMessage({ id: 'page.reviews-metadescription' })}`

  const canonicalURL = buildCanonicalURL({
    market,
    language,
    pathname: '/reviews',
    subdomain,
    topdomain,
  })

  return (
    <Head>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={canonicalURL} />
      <script type="application/ld+json">{getJsonLd(market)}</script>
    </Head>
  )
}
